/**
 * @author    Labs64 <netlicensing@labs64.com>
 * @license   Apache-2.0
 * @link      https://netlicensing.io
 * @copyright 2017 Labs64 NetLicensing
 */
const ApiKeyRole = Object.freeze({
  ROLE_APIKEY_LICENSEE: 'ROLE_APIKEY_LICENSEE',
  ROLE_APIKEY_ANALYTICS: 'ROLE_APIKEY_ANALYTICS',
  ROLE_APIKEY_OPERATION: 'ROLE_APIKEY_OPERATION',
  ROLE_APIKEY_MAINTENANCE: 'ROLE_APIKEY_MAINTENANCE',
  ROLE_APIKEY_ADMIN: 'ROLE_APIKEY_ADMIN',
});

export default ApiKeyRole;
